import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import staticQueryData from "../../../../../../public/static/d/1968367593.json";
/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import { StaticQuery } from 'gatsby';
import { mergeProps } from '@arcblock/ux/lib/Util';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ForwardIcon from '@material-ui/icons/ArrowForward';
import Link from '../link';
import PostCard from '../post_card';
import filterPost from './filter';
import './style.css';
var translations = {
  en: {
    viewAll: 'View All',
    viewMore: 'View More'
  },
  zh: {
    viewAll: '查看所有',
    viewMore: '继续阅读'
  }
};
export default function LatestPostList(props) {
  var newProps = mergeProps(props, LatestPostList, ['limit', 'showViewAll']);
  var category = newProps.category,
      tag = newProps.tag,
      limit = newProps.limit,
      showViewAll = newProps.showViewAll;
  var locale = translations[newProps.locale] ? newProps.locale : 'en';
  var viewMore = newProps.viewMore || translations[locale].viewMore;
  var viewAll = newProps.viewAll || translations[locale].viewAll;
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: "1968367593",
    render: function render(data) {
      var all = data.news.edges.map(function (x) {
        return x.node;
      });
      var posts = all.filter(function (x) {
        return filterPost({
          post: x,
          locale: locale,
          tag: tag,
          category: category
        });
      }); // eslint-disable-next-line no-nested-ternary

      var moreUrl = category ? "/categories/" + category : tag ? "/tags/" + tag : '';
      return /*#__PURE__*/React.createElement(Grid, {
        className: "post-latest",
        container: true,
        spacing: 0
      }, posts.slice(0, limit).map(function (post) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: post.frontmatter.path,
          item: true,
          xs: 12,
          sm: 6,
          md: 4,
          lg: 3
        }, /*#__PURE__*/React.createElement(PostCard, {
          post: post,
          viewMore: viewMore
        }));
      }), !!moreUrl && showViewAll && /*#__PURE__*/React.createElement(Grid, {
        key: "view-more",
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        className: "view-more-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "view-more"
      }, /*#__PURE__*/React.createElement(Link, {
        to: moreUrl
      }, /*#__PURE__*/React.createElement(Button, {
        color: "default",
        className: "btn-view-more"
      }, viewAll, /*#__PURE__*/React.createElement(ForwardIcon, {
        style: {
          marginLeft: '8px'
        }
      }))))));
    },
    data: staticQueryData
  });
}
LatestPostList.defaultProps = {
  locale: 'en',
  category: '',
  tag: '',
  limit: 7,
  showViewAll: true,
  viewAll: '',
  viewMore: ''
};